import branchManagementCountVariancesComponent from "./count_variances.component";

let branchManagementCountVariancesModule = angular.module("branchManagementCountVariances", [

])
    .component("branchManagementCountVariances", branchManagementCountVariancesComponent)
    .name;

export default branchManagementCountVariancesModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/count_variances/index.js